import { isMobile } from "react-device-detect";
import styled from "styled-components";

export const CheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding-right: ${isMobile ? "10px" : "0px"};
`;

export const LinkFatura = styled.a`
  text-decoration: none;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 18pt;
  margin-top: 20px;
  color: #39a9dc;
  cursor: pointer;
  margin-bottom: 30px;
`;

export const CompraSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DogCatContainer = styled.img`
  height: 200px;
  width: auto;
  margin-bottom: 40px;
  margin-top: 40px;
`;

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const EmailImage = styled.a`
  cursor: pointer;
  text-decoration: none;
`;

export const AtivacaoAssinatura = styled.p`
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 12pt;
  color: #58585A;
`;

export const ThanksMessageContainer = styled.img`
  height: 150px;
  width: auto;
`;

export const CompraSucessTitle = styled.h4`
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 46pt;
  margin-top: 20px;
  color: #9c9e9f;
`;

export const LoginForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: flex-start;
  width: 98% !important;
  margin-left: 10px;
  margin-bottom: 20px;

  @media (min-width: 1439px) {
    width: 48.5% !important;
    margin-left: 0px;
  }
`;

export const RegisterForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: flex-start;
  width: 98% !important;
  margin-left: 10px;
  margin-bottom: 20px;

  @media (min-width: 1439px) {
    width: 48.5% !important;
    margin-left: 0px;
  }
`;

export const LoginTittle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AlreadyRegister = styled.p`
  font-size: 11.31pt;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #9c9e9f;
`;

export const NotRegister = styled.p`
  font-size: 11.31pt;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #39a9dc;
`;

export const Divider = styled.div`
  border-top: 1.8px solid #c6c7c8;
  width: 48.5%;
  -webkit-box-shadow: 10px 10px 17px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 17px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 17px -10px rgba(0, 0, 0, 0.75);
  margin-bottom: 20px;
`;
